import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import grey from '@material-ui/core/colors/grey';
import Typography from '@material-ui/core/Typography';
import { routePage } from '../store/route-page';

class ListHeader extends Component {
  render() {
    const { t } = this.props;
    const counterText = t('messages.stopCounter', { ordered: routePage.orderedAddresses.length, total: routePage.addresses.length });
    return (
      <Typography variant="h6" align="center" style={{ borderBottom: `1px solid ${grey[400]}` }}>{counterText}</Typography>
    );
  }
}

ListHeader.propTypes = { t: PropTypes.func.isRequired };

export default withNamespaces()(observer(ListHeader));



// WEBPACK FOOTER //
// ./src/components/ListHeader.js